// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Fort_awesome_iconJsx from "./fort_awesome_icon.jsx";

var make = Fort_awesome_iconJsx.FontAwesomeIcon;

var FortAwesomeIcon = {
  make: make
};

function FontAwesomeIcon(props) {
  return React.createElement(make, {
              icon: [
                Belt_Option.getWithDefault(props.prefix, "fas"),
                props.iconName
              ],
              size: props.size,
              color: props.color,
              flip: props.flip,
              className: props.className,
              style: props.style,
              onClick: props.onClick,
              "aria-hidden": props.ariaHidden,
              ref: props.iconRef,
              tabIndex: props.tabIndex
            });
}

var make$1 = FontAwesomeIcon;

export {
  FortAwesomeIcon ,
  make$1 as make,
}
/* make Not a pure module */
